/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { createBlacklistValidator } from 'src/core/utils/formValidators/createBlacklistValidator';
import { createDuplicateValueValidator } from 'src/core/utils/formValidators/createDuplicateValueValidator';
import { createExtensionValidator } from 'src/core/utils/formValidators/createExtensionValidator';
import { createLengthValidator } from 'src/core/utils/formValidators/createLengthValidator';
import { createNumberRangeValidator } from 'src/core/utils/formValidators/createNumberRangeValidator';
import { createRequiredValidator } from 'src/core/utils/formValidators/createRequiredValidator';

export const FormValidators = {
    createRequiredValidator,
    createBlacklistValidator,
    createExtensionValidator,
    createNumberRangeValidator,
    createDuplicateValueValidator,
    createLengthValidator
};
